import { gql } from "@apollo/client";

const CALCULATE_LEAGUE_POINTS = gql`
  query calculateLeaguePoints($filter: ListTournamentRankingsEntryInput!) {
    calculateLeaguePoints(filter: $filter)
  }
`;

export default CALCULATE_LEAGUE_POINTS;
